import React from "react";
import ToolDescriptionCard from "./ToolDescriptionCard";
import SkilledWorker from "../../assets/female-artisan-smiling.png";
import { logEvent } from "helpers/analytics";
import { useHistory } from "react-router";

export default function SkilledWorkersToolFinancingView() {
  const navigate = useHistory().push;

  return (
    <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-14">
      <div className="w-full h-full">
        <img
          className="w-full h-[283px]  lg:h-full"
          src={SkilledWorker}
          alt="Female skilled worker"
        />
      </div>
      <div className="h-full">
        <ToolDescriptionCard
          title="Tool Financing"
          actionText="Get funding for your work tools"
          description="Get the financial support you need to upgrade your tools without stress. Start working smarter with high-quality equipment and flexible repayment plans."
          ctaText="Learn more"
          handleCTAClick={() => {
            logEvent("skilled_workers_landing_page_cta_click", {
              interest: "tool_financing",
            });

            navigate("/tools-financing");
          }}
        />
      </div>
    </div>
  );
}
